import styled from "styled-components";

const SettingButton = styled.button`
    font-size: 30px;
    margin: 30px;
    padding: 10px;
`

export default SettingButton